/**
 * 会员权益配置
 */
export const memberOptions = [
    {
      title: '超大空间',
      icon: require('@/assets/member_equity_0.png')
    },
    {
      title: '无限提取文件',
      icon: require('@/assets/member_equity_1.png')
    },
    {
      title: '无限上传文件', 
      icon: require('@/assets/member_equity_2.png')
    },
    {
      title: '在线解压',
      icon: require('@/assets/member_equity_3.png')
    },
    {
      title: '极速下载',
      icon: require('@/assets/member_equity_4.png')
    },
    {
      title: '原画视频上传',
      icon: require('@/assets/member_equity_5.png')
    },
    {
      title: '视频高清播放',
      icon: require('@/assets/member_equity_6.png')
    },
    {
      title: '大文件上传',
      icon: require('@/assets/member_equity_7.png')
    },
    {
      title: '回收站保留',
      icon: require('@/assets/member_equity_8.png')
    },
    {
      title: '身份标识',
      icon: require('@/assets/member_equity_9.png')
    }
  ]


// WEBPACK FOOTER //
// ./src/utils/member-options.js